import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token && !config.headers?.Authorization) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use((response) => response, (error) => {
  if (String(error.config?.method || "").toLowerCase() === "get") window.dispatchEvent(new CustomEvent("view-load-error", { detail: error.response?.data?.error || "An error occurred while loading this view." }));
  return Promise.reject(error);
});

export default api;
